import './css/styles.css'
import { createApp, defineAsyncComponent } from 'vue';
// FormKit.
import { plugin, defaultConfig } from '@formkit/vue'
// Captcha.
import { VueReCaptcha } from 'vue-recaptcha-v3';
import router from './router';
import store from './store/store';

// Global Components
import BasicContainer from './components/UI/BasicContainer.vue';
import CartContainer from './components/UI/CartContainer.vue';
// Use BaseDialog whenever it is needed.
const BaseDialog = defineAsyncComponent(()=> import('@/components/UI/BaseDialog.vue'));

import App from './App.vue'

const app = createApp(App);
app.component('BasicContainer', BasicContainer);
app.component('CartContainer', CartContainer);
app.component('base-dialog', BaseDialog);
// FormKit.
app.use(plugin, defaultConfig);
app.use(router);
app.use(store);
app.use(VueReCaptcha, {
    siteKey: "6LcHlP8qAAAAACUGeEy9Luk9wL-DG6_TBzQtmkIk",
    cnDomains: false, // Optional, If you use in China, set this value true
});
app.mount('#app');
